import {algorithFieldListObj} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/edit-trade-service/algorith-fieldlist-obj";
import {TradeInstructionsComponent} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component";
import {getDestinations} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.model";
import {
  formatDestinations, formatDestinationsReverse,
  formatOrderType,
  formatOrderTypeReverse,
  formatSecurityTypeReverse, formatTransactionReverse
} from "@irb-common/formatters";

export function itemsVariousVsValue(multiRecords: any[], self: TradeInstructionsComponent) {

  const multiRecordsLength = multiRecords.length;

  const multiRecordsFirstItem = JSON.parse(JSON.stringify(multiRecords[0]));
  multiRecordsFirstItem.variousFields = [];
  multiRecordsFirstItem.securitySymbolFilteredVarious = false;
  multiRecordsFirstItem.defaultOrderPriceTypeFilteredVarious = false;
  multiRecordsFirstItem.preOrderType = multiRecordsFirstItem.orderType;
  var orderTypeFiltered = multiRecords.filter( (item) => {
    return item.orderType == multiRecordsFirstItem.orderType;
  });
  /*var shareQuantityFiltered = multiRecords.filter( (item) => {
    return item.quantity > 3000;
  });*/
  var notHeldFiltered = multiRecords.filter( (item) => {
    return item.ordIsNotHeld == true;
  });
  let isSolicited = multiRecords.filter((item)=>{ return item.isSolicited == true });
  let isDiscretionary = multiRecords.filter((item)=>{ return item.isDiscretionary == true });
  multiRecordsFirstItem.optionRecordsPresent = ((multiRecords.filter( (item) => {
    return formatSecurityTypeReverse(item.securityType) == "OPTION";
  })).length); //Defect #148469
  multiRecordsFirstItem.equityRecordsPresent = ((multiRecords.filter( (item) => {
    return formatSecurityTypeReverse(item.securityType) == "EQUITY";
  })).length); //IREBALUX-1213
  multiRecordsFirstItem.mutualFundRecordsPresent = ((multiRecords.filter( (item) => {
    return formatSecurityTypeReverse(item.securityType) == "MUTUAL_FUND";
  })).length);
  //added for IREBALUX-170 start
  self.blockdeskrecordspresent = ((multiRecords.filter( (item) => {
    return formatDestinationsReverse(item.notHeldDestination) == "AOM_PRINTER";
  })).length > 0); //IREBALUX-1507 - Prevent Limit Orders when Destination is Set to Block Desk

  multiRecordsFirstItem.showAllTransactionTypeSellAll = ((multiRecords.filter( (item) => {
    return (formatTransactionReverse(item.transactionType) == "SELL" || formatTransactionReverse(item.transactionType) == "SELL_ALL");
  })).length == multiRecordsLength);
  /*
       * IREBALUX-3484 & IREBALUX-3342
       * Not Held Order Destinations and Available Order Types
       */
  multiRecordsFirstItem.notHeldDistAlgor = ((multiRecords.filter( (item) => {
    return (formatOrderTypeReverse(item.orderType) == "TRAILING_STOP_PRC" || formatOrderTypeReverse(item.orderType) == "TRAILING_STOP_DOLLAR" || formatOrderTypeReverse(item.orderType) == "STOP" || formatOrderTypeReverse(item.orderType == "STOPLIMIT"));
  })).length);

  /**
   * IREBALUX-1213
   * If multiple equity orders are selected for the same symbol and all have the same transaction type (all sells or all buys),
   * the Edit Trade Instructions modal launched from the new button should allow the user to specify the order type as either Stop or Stop Limit (same as in-line single order edit).
   * It should use the same order validations as the in-line edit.
   */
  multiRecordsFirstItem.showAllOrderTypeSelections = false;
  if (multiRecordsLength == 1) {
    /** IREBALUX-1213
     * If 1 equity or option order is selected (1 symbol), the Edit Trade Instructions modal launched from
     * the new button should allow the user to specify the order type as either Stop or Stop Limit (same as in-line single order edit).
     * It should use the same order validations as the in-line edit.
     * */
    multiRecordsFirstItem.showAllOrderTypeSelections = true;
  } else {
    var allRecordsSameSecType = ((multiRecordsFirstItem.optionRecordsPresent == multiRecordsLength) || (multiRecordsFirstItem.equityRecordsPresent == multiRecordsLength)
      || (multiRecordsFirstItem.mutualFundRecordsPresent == multiRecordsLength));
    if (allRecordsSameSecType) {
      var allRecordsSameSybl = ((multiRecords.filter( (item) => {
        return item.securitySymbol == multiRecordsFirstItem.securitySymbol;
      })).length == multiRecordsLength);
      if (allRecordsSameSybl) {
        /**
         * If multiple equity/option orders are selected for the same symbol
         */
        var tranTypeList = ["SELL", "BUY", "SELL_TO_OPEN", "SELL_TO_CLOSE", "BUY_TO_OPEN", "BUY_TO_CLOSE"];
        for (var i = 0; i < tranTypeList.length; i++) {
          /**
           * all have the same transaction type (all sells or all buys)
           * IREBALUX-1213 - 9th point consider sell and sell all as one
           */
          var node = tranTypeList[i];
          multiRecordsFirstItem.showAllOrderTypeSelections = (node == "SELL") ? ((multiRecords.filter( (item) => {
            return (formatTransactionReverse(item.transactionType) == "SELL" || formatTransactionReverse(item.transactionType) == "SELL_ALL");
          })).length == multiRecordsLength) : ((multiRecords.filter( (item) => {
            return formatTransactionReverse(item.transactionType) == node;
          })).length == multiRecordsLength);
          if (multiRecordsFirstItem.showAllOrderTypeSelections) {
              break;
          }
        }
      }
    }
  }
  /*
       * Order type dropdown field should only have 2 options available: Market or Limit.
       * As part of the MVP, we will not allow users to add Stop or Stop Limit order type instructions when editing multiple orders.
       */
  // dijit.byId('orderType').query = {
  //   destType: getDestinationQ()
  // }; //IREBALUX-1507 - Prevent Limit Orders when Destination is Set to Block Desk
  self.setDestination();
  //IREBALUX-11619
  // if (multiRecordsLength != multiRecordsFirstItem.mutualFundRecordsPresent) {
  //   multiRecordsFirstItem.securityType = null;
  //   multiRecordsFirstItem.variousFields.push("securityType");
  // }
  let expirationTypeFiltered = [];
  let gtdOrGTDExtFiltered = [];
  for (let i = 0; i < multiRecords.length; i++) {
    const item = multiRecords[i];
    let expirationType = item.expirationType;
    if (expirationType == multiRecordsFirstItem.expirationType) {
      expirationTypeFiltered.push(item);
    }
    if (!expirationType) {expirationType = ''};
    if (expirationType.toLowerCase().startsWith('gtd') ) {
      gtdOrGTDExtFiltered.push(item);
    }
  }
  if (multiRecordsLength != expirationTypeFiltered.length) {
    multiRecordsFirstItem.expirationType = null;
    multiRecordsFirstItem.variousFields.push("expirationType");
    self.expTypeSelected = null;
  }
  // added for IREBALUX-170 end

  if (multiRecordsLength == expirationTypeFiltered.length || multiRecordsLength == gtdOrGTDExtFiltered.length) {
    //added for IREBALUX-171 start
    var expirationDateFiltered = multiRecords.filter( (item) => {
      return item.expirationDate == multiRecordsFirstItem.expirationDate;
    });
    if (multiRecordsLength != expirationDateFiltered.length) {
      multiRecordsFirstItem.expirationDate = null;
      multiRecordsFirstItem.variousFields.push("expirationDate");
      self.expirationDate = null;
      self.isShowExpDateVarious = true;
      self.expirationDateDisabled = false;
    }
  }

  if (multiRecordsLength != orderTypeFiltered.length) {
    multiRecordsFirstItem.orderType = null;
    multiRecordsFirstItem.price = null;
    multiRecordsFirstItem.variousFields.push("orderType");
    multiRecordsFirstItem.variousFields.push("price");
    self.orderTypeSelected = null;
    self.price = null;
    self.expirationTypeDisabled = true;
    self.expirationDateDisabled = true;
    self.isShowPriceVarious = true;
  }
  let securitySymbolFiltered = multiRecords.filter( (item) => {
    return item.securitySymbol == multiRecordsFirstItem.securitySymbol;
  });
  if (multiRecordsLength == orderTypeFiltered.length) {
    if (formatOrderTypeReverse(multiRecordsFirstItem.orderType) == "STOPLIMIT") {

      var limitpriceFiltered = multiRecords.filter( (item) => {
        return item.price == multiRecordsFirstItem.price;
      });
      var stoppriceFiltered = multiRecords.filter( (item) => {
        return item.ordStopPrice == multiRecordsFirstItem.ordStopPrice;
      });

      if (multiRecordsLength != limitpriceFiltered.length) {
        multiRecordsFirstItem.ordLimitPrice = null;
        multiRecordsFirstItem.price = null;
        multiRecordsFirstItem.variousFields.push("limitprice");
        self.limitPrice = null;
        self.price = null;
        self.isShowLimitPriceVarious = true;
      }

      if (multiRecordsLength != stoppriceFiltered.length) {
        multiRecordsFirstItem.ordStopPrice = null;
        multiRecordsFirstItem.variousFields.push("stopprice");
        self.stopPrice = null;
        self.isShowStopPriceVarious = true;
      }

    } else if (formatOrderTypeReverse(multiRecordsFirstItem.orderType) == "STOP" || formatOrderTypeReverse(multiRecordsFirstItem.orderType) == "MARKET" ||
      formatOrderTypeReverse(multiRecordsFirstItem.orderType) == "TRAILING_STOP_DOLLAR" || formatOrderTypeReverse(multiRecordsFirstItem.orderType) == "TRAILING_STOP_PRC") {
      let priceFiltered = multiRecords.filter( (item) => {
        return item.price == multiRecordsFirstItem.price;
      });
      if (multiRecordsLength != priceFiltered.length) {
        multiRecordsFirstItem.price = null;
        multiRecordsFirstItem.variousFields.push("price");
        self.price = null;
        self.isShowPriceVarious = true;
      }
    } else if (formatOrderTypeReverse(multiRecordsFirstItem.orderType) == "LIMIT" ) { //IREBALUX-1857
      var limitPriceTypeFiltered = multiRecords.filter( (item) => {
        return item.defaultOrderPriceType == multiRecordsFirstItem.defaultOrderPriceType;
      });
      if (multiRecordsLength != limitPriceTypeFiltered.length) {
        multiRecordsFirstItem.price = null;
        multiRecordsFirstItem.variousFields.push("price");
        multiRecordsFirstItem.variousFields.push("priceType");
        multiRecordsFirstItem.defaultOrderPriceTypeFilteredVarious = true;
        multiRecordsFirstItem.defaultOrderPriceType = null;
        self.price = null;
        self.priceTypeSelected = null;
        self.isShowPriceVarious = true;
      } else {
        if (multiRecordsFirstItem.defaultOrderPriceType == "None") {
          let priceFiltered = multiRecords.filter( (item) => {
            return item.price == multiRecordsFirstItem.price;
          });

          if (multiRecordsLength != priceFiltered.length) {
            multiRecordsFirstItem.price = null;
            multiRecordsFirstItem.variousFields.push("price");
            self.price = null;
            self.isShowPriceVarious = true;
          }
        } else {
          if (multiRecordsLength != securitySymbolFiltered.length) {
            multiRecordsFirstItem.price = null;
            multiRecordsFirstItem.variousFields.push("price");
            self.price = null;
            self.isShowPriceVarious = true;
          }
        }

      }
    }
  }

  /*if (multiRecordsLength != shareQuantityFiltered.length) {
    multiRecordsFirstItem.quantity = 0;
    // dijit.byId('notHeldDestination').query = {
    //   id: "AOM_PRINTER"
    // };
    // dijit.byId("notHeldDestination").set("value", "AOM_PRINTER");
    self.notHeldDestinations = self.getFilteredArray(getDestinations({Block_Desk_Not_Held: true}), 'permissions', true);
    if (self.data.notHeldDestination && self.data.notHeldDestination.id === 'AOM_PRINTER') {
      self.notHeldDestinationSelected = self.notHeldDestinations[0];
      if (self.notHeldDestinationElem) {
        self.notHeldDestinationElem.value = self.notHeldDestinationSelected;
      }
    }

  } else {
    // dijit.byId('notHeldDestination').query = {
    //   "permissions": true
    // };
    self.notHeldDestinations = self.getFilteredArray(getDestinations(self.algorithmPermissionsObj.algorithmPermissionsList), 'permissions', true);
    multiRecordsFirstItem.quantity = 3001;
  }*/
  self.notHeldDestinations = self.getFilteredArray(getDestinations(self.algorithmPermissionsObj.algorithmPermissionsList), 'permissions', true);

  if (multiRecordsLength != securitySymbolFiltered.length) {
    multiRecordsFirstItem.ordLimitPrice = null;
    multiRecordsFirstItem.securitySymbolFilteredVarious = true;
  }

  if (multiRecordsLength != notHeldFiltered.length && notHeldFiltered.length > 0) {
    multiRecordsFirstItem.ordIsNotHeld = false;
    multiRecordsFirstItem.notHeldDestination = null;
    multiRecordsFirstItem.variousFields.push("ordIsNotHeld");
    self.isShowNotHeldVarious = true;
  } else if (multiRecordsLength == notHeldFiltered.length) {
    self.isShowNotHeldVarious = false;
    var notHeldDestinationFiltered = multiRecords.filter( (item) => {
      return item.notHeldDestination == multiRecordsFirstItem.notHeldDestination;
    });

    if (multiRecordsLength == notHeldDestinationFiltered.length) {
      if (multiRecordsFirstItem.notHeldDestination == "AOM_PRINTER") {
        var userContactNoFiltered = multiRecords.filter( (item) => {
          return item.userContactNo == multiRecordsFirstItem.userContactNo;
        });
        if (multiRecordsLength != userContactNoFiltered.length) {
          multiRecordsFirstItem.notHeldDestination = null;
          multiRecordsFirstItem.userContactNo = null;
        }

      } else {
        var notHeldAlgorithmFiltered = multiRecords.filter( (item) => {
          return item.notHeldAlgorithm == multiRecordsFirstItem.notHeldAlgorithm;
        });
        if (multiRecordsLength == notHeldAlgorithmFiltered.length) {

          var currentFields = algorithFieldListObj(multiRecordsFirstItem.notHeldDestination, multiRecordsFirstItem.notHeldAlgorithm);
          var listofFields = currentFields.length ? currentFields[0].listofFields : [];
          for (var i = 0; i < listofFields.length; i++) {

            var matchFields = multiRecords.filter( (item) => {
              return item[listofFields[i]] == multiRecordsFirstItem[listofFields[i]];
            });
            if (matchFields.length != multiRecordsLength) {
              // multiRecordsFirstItem.notHeldDestination = null;
              // break;
              multiRecordsFirstItem[listofFields[i]] = null;
              multiRecordsFirstItem.variousFields.push(listofFields[i]);
            }

          }



        } else if (multiRecordsLength != notHeldAlgorithmFiltered.length) {
          multiRecordsFirstItem.notHeldAlgorithm = null;
        }
      }
    } else if (multiRecordsLength != notHeldDestinationFiltered.length) {
      multiRecordsFirstItem.notHeldDestination = null;
    }

  } else {
    self.isShowNotHeldVarious = false;
  }

  if (multiRecordsLength != isSolicited.length && isSolicited.length > 0) {
    multiRecordsFirstItem.isSolicited = false;
    multiRecordsFirstItem.variousFields.push("isSolicited");
    self.isSolictedVarious = true;
  } else if (multiRecordsLength == isSolicited.length) {
    self.isSolictedVarious = false;
    self.isSolicited = multiRecords[0].isSolicited;
  } else {
    self.isSolictedVarious = false;
    multiRecordsFirstItem.isSolicited = false;
  }
  if (multiRecordsLength != isDiscretionary.length && isDiscretionary.length > 0) {
    multiRecordsFirstItem.isDiscretionary = false;
    multiRecordsFirstItem.variousFields.push("isDiscretionary");
    self.isDiscretionaryVarious = true;
  } else if (multiRecordsLength == isDiscretionary.length) {
    self.isDiscretionaryVarious = false;
    self.isDiscretionary = multiRecords[0].isDiscretionary;
  } else {
    self.isDiscretionaryVarious = false;
    multiRecordsFirstItem.isDiscretionary = false;
  }
  return multiRecordsFirstItem;

}
